import SecureLS from 'secure-ls'

var ls = new SecureLS({encodingType: 'aes', isCompression: false})
export const setValue = function(key, value, inst = 0, cust = 0) {
  let k = key + '-' + inst + '-' + cust
  if (Object.prototype.hasOwnProperty.call(window.localStorage, key)) {
    window.localStorage.removeItem(key)
  }
  ls.set(k, value)
}
export const getValue = function(key, inst = 0, cust = 0) {
  let k = key + '-' + inst + '-' + cust
  if (Object.prototype.hasOwnProperty.call(window.localStorage, key)) {
    try {
      ls.set(k, ls.get(key))
    } catch (e) {
      ls.set(k, window.localStorage.getItem(key))
    }
    window.localStorage.removeItem(key)
  }
  return ls.get(k)
}
export const removeValue = function(key, inst = 0, cust = 0) {
  let k = key + '-' + inst + '-' + cust
  if (Object.prototype.hasOwnProperty.call(window.localStorage, key)) {
    window.localStorage.removeItem(key)
  }
  return ls.remove(k)
}
export const hasValue = function(key, inst = 0, cust = 0) {
  let k = key + '-' + inst + '-' + cust
  if (Object.prototype.hasOwnProperty.call(window.localStorage, key)) {
    try {
      ls.set(k, ls.get(key))
    } catch (e) {
      ls.set(k, window.localStorage.getItem(key))
    }
    window.localStorage.removeItem(key)
  }
  return !!ls.get(k)
}
